export class ReportBlockedError extends Error {}
